import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
} from 'reactstrap';
import { toast } from 'react-toastify';
import api from '~/services/api';

/**
 * Confirmação de reativação de webhook auto-desabilitado.
 *
 * O backend só permite reativar webhooks com auto_disabled_at preenchido.
 * Caso contrário lança WebhookNotAutoDisabledException (provavelmente 400/422).
 *
 * Props:
 *   show, setShow
 *   webhook
 *   onReactivated   callback após sucesso (recebe o webhook atualizado)
 */
export default function ReactivateWebhookModal({
  show,
  setShow,
  webhook,
  onReactivated,
}) {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    setShow(false);
  };

  const handleReactivate = async () => {
    if (!webhook?.id) return;
    setLoading(true);
    try {
      const { data } = await api.post(
        `administrator/partner-webhooks/${webhook.id}/reactivate`
      );
      toast.success('Webhook reativado com sucesso!');
      setShow(false);
      if (onReactivated) onReactivated(data?.data || data);
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error('Não foi possível reativar o webhook.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Reativar webhook</ModalHeader>
      <ModalBody>
        <Alert color="info">
          O webhook foi desativado automaticamente após{' '}
          <strong>15 falhas consecutivas</strong> de entrega. Reativando, o
          contador zera e ele volta a receber eventos imediatamente.
        </Alert>

        <div className="mb-2">
          <strong>Aplicação:</strong>{' '}
          {webhook?.partner_application?.name || '—'}
        </div>
        <div
          className="mb-2 text-truncate"
          style={{
            fontFamily: '"JetBrains Mono", Menlo, monospace',
            fontSize: '12px',
            color: '#374151',
          }}
        >
          <strong>URL:</strong> {webhook?.url}
        </div>
        <div className="text-muted" style={{ fontSize: '13px' }}>
          Confirme apenas se o problema do endpoint do parceiro já foi
          resolvido. Caso contrário, ele será auto-desabilitado de novo após
          mais 15 falhas.
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color="success"
          className="new-layout-btn main"
          onClick={handleReactivate}
          disabled={loading}
        >
          {loading ? 'Reativando...' : 'Sim, reativar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
